import React from 'react'
import Styles from './footer.module.css'
function Footer() {
  return (
    <div className={Styles.footer}>
      <div style={{paddingLeft:"10px"}}>
        Powered by gameex
      </div>
      <div style={{paddingRight:"10px"}}>
        gamesEx © 2025
      </div>
    </div>
  )
}

export default Footer